import _classCallCheck from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import { Slider } from './slider.js';
import { hsvaToHslString } from '../utils/convert.js';
import { clamp, round } from '../utils/math.js';
export var Saturation = /*#__PURE__*/function (_Slider) {
  _inherits(Saturation, _Slider);
  var _super = _createSuper(Saturation);
  function Saturation(root) {
    _classCallCheck(this, Saturation);
    return _super.call(this, root, 'saturation', 'aria-label="Color"', true);
  }
  _createClass(Saturation, [{
    key: "update",
    value: function update(hsva) {
      this.hsva = hsva;
      this.style([{
        top: "".concat(100 - hsva.v, "%"),
        left: "".concat(hsva.s, "%"),
        color: hsvaToHslString(hsva)
      }, {
        'background-color': hsvaToHslString({
          h: hsva.h,
          s: 100,
          v: 100,
          a: 1
        })
      }]);
      this.el.setAttribute('aria-valuetext', "Saturation ".concat(round(hsva.s), "%, Brightness ").concat(round(hsva.v), "%"));
    }
  }, {
    key: "getMove",
    value: function getMove(offset, key) {
      // Saturation and brightness always fit into [0, 100] range
      return {
        s: key ? clamp(this.hsva.s + offset.x * 100, 0, 100) : offset.x * 100,
        v: key ? clamp(this.hsva.v - offset.y * 100, 0, 100) : Math.round(100 - offset.y * 100)
      };
    }
  }]);
  return Saturation;
}(Slider);